module.exports = __webpack_public_path__ + "img/avatar-s-25.796705f9.jpg";